import Api from 'api';

import {
  GET_NOTIFICATIONS_CONFIG,
  SET_NOTIFICATIONS_CONFIG_PAGINATION,
  SET_NOTIFICATIONS_CONFIG_FILTERS,
  RESET_NOTIFICATIONS_CONFIG,
  TOGGLE_NOTIFICATION_CONFIG,
  ADD_NOTIFICATION_CONFIG,
  UPDATE_NOTIFICATION_CONFIG,
  GET_NOTIFICATION_CONFIG_BY_ID,
  RESET_NOTIFICATION_CONFIG_FORM,
  GET_NOTIFICATION_CONFIG_FORM_CONFIG,
  MODIFY_EDITING_NOTIFICATION_CONFIG,
  MODIFY_CUSTOM_FIELD_EDITING_NOTIFICATION_CONFIG, //Groups
  ADD_CUSTOM_FIELD_EDITING_NOTIFICATION_CONFIG,
  REMOVE_CUSTOM_FIELD_EDITING_NOTIFICATION_CONFIG,
  UPDATE_SELF_NOTIFICATION_CONFIG,
} from 'notifications_config/constants';

import { SET_LISTS } from 'containers/lists/constants';

export const setPagination = (payload) => ({
  type: SET_NOTIFICATIONS_CONFIG_PAGINATION,
  payload,
});

export const setFilters = (payload) => ({
  type: SET_NOTIFICATIONS_CONFIG_FILTERS,
  payload,
});

export const getNotificationsConfig = (
  companyId,
  subcompanyId,
  filters,
  limit,
  page,
  orderBy,
  order
) => ({
  type: GET_NOTIFICATIONS_CONFIG,
  meta: { needAuth: true },
  payload: Api.notifications_config.get(
    companyId,
    subcompanyId,
    filters,
    limit,
    page,
    orderBy,
    order
  ),
});

export const reset = () => ({ type: RESET_NOTIFICATIONS_CONFIG });

export const toggle = (notificationConfigId, companyId, subcompanyId) => ({
  type: TOGGLE_NOTIFICATION_CONFIG,
  meta: { id: notificationConfigId, needAuth: true },
  payload: Api.notifications_config.toggle(notificationConfigId, companyId, subcompanyId),
});

export const resetForm = () => ({ type: RESET_NOTIFICATION_CONFIG_FORM });

export const getNotificationConfigById = (notificationConfigId, companyId, subcompanyId) => ({
  type: GET_NOTIFICATION_CONFIG_BY_ID,
  meta: { needAuth: true },
  payload: Api.notifications_config.getById(notificationConfigId, companyId, subcompanyId),
});

export const getFormConfig = (companyId, subcompanyId) => (dispatch) =>
  dispatch({
    type: GET_NOTIFICATION_CONFIG_FORM_CONFIG,
    meta: { needAuth: true },
    payload: Api.notifications_config.formConfig(companyId, subcompanyId),
  }).then(({ value: { notification_config, depreciations } }) => {
    dispatch({
      type: SET_LISTS,
      payload: {
        notification_config,
        depreciations,
      },
    });
  });

export const modifyNotificationConfig = (payload) => ({
  type: MODIFY_EDITING_NOTIFICATION_CONFIG,
  payload,
});

//Groups
export const modifyCustomField = (payload) => ({
  type: MODIFY_CUSTOM_FIELD_EDITING_NOTIFICATION_CONFIG,
  payload,
}); // Agregado

export const addNotificationConfig = (companyId, subcompanyId, notificationConfig) => ({
  type: ADD_NOTIFICATION_CONFIG,
  payload: Api.notifications_config.add(companyId, subcompanyId, notificationConfig),
});

export const updateNotificationConfig = (
  notificationConfigId,
  companyId,
  subcompanyId,
  notificationConfig
) => ({
  type: UPDATE_NOTIFICATION_CONFIG,
  meta: { id: notificationConfigId, needAuth: true },
  payload: Api.notifications_config.update(
    notificationConfigId,
    companyId,
    subcompanyId,
    notificationConfig
  ),
});

export const updateSelfNotificationConfig = (notificationConfig) => {
  console.log(notificationConfig);
  // return ({
  // type: UPDATE_SELF_NOTIFICATION_CONFIG,
  // meta: { needAuth: true },
  // payload: Api.auth.updateInfo(
  //   notificationConfig
  // )
  //   }
  // )
};

/*
{
	"name": "prueba cambio",
	"lastname": "pruba 2",
	"password":	"admin12345"
}
*/

export const addCustomField = () => ({ type: ADD_CUSTOM_FIELD_EDITING_NOTIFICATION_CONFIG });

export const removeCustomField = (index) => ({
  type: REMOVE_CUSTOM_FIELD_EDITING_NOTIFICATION_CONFIG,
  payload: index,
});



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_config/actions/notifications_config_actions.js